import type { ShipDef } from '../../sim/defs';
import { Stat } from '../../sim/stats';

/** V02 — FANAL. « Aucune bombe, jamais. Recharge des armes secondaires deux
 *  fois plus rapide » (nœud `vaisseau-fanal`, 1 800 crédits, ouvert par le
 *  jalon « vaincre un boss sans lâcher une bombe »).
 *
 *  ── Pourquoi la suppression est MULTIPLICATIVE ────────────────────────────
 *  `maxBombs × 0` et non `maxBombs − 2`. Le nœud promet « jamais », et un
 *  additif ne tient pas cette promesse : les cartes du pool ajoutent des bombes
 *  (`utilitaires.def.ts`), et `computeStats` applique TOUS les additifs avant
 *  TOUS les multiplicatifs. Avec −2, une seule carte « +1 bombe » rendrait au
 *  FANAL le bouton qu'il a vendu ; avec ×0, l'ordre d'application garantit que
 *  le total, quel qu'il soit, retombe à zéro. La promesse est portée par
 *  l'ARITHMÉTIQUE et pas par la discipline du contenu à venir.
 *
 *  ── L'échange ────────────────────────────────────────────────────────────
 *  Deux bombes, c'est deux sorties de secours et 3,2 s d'invulnérabilité
 *  gratuites par run — de très loin ce que le VULCAN a de plus précieux. En
 *  face, la recharge de secondaire divisée par deux transforme une arme
 *  tactique en présence permanente : c'est la seule coque qui joue sa
 *  secondaire comme une ressource continue plutôt que comme une décision rare.
 *
 *  ⚠️ Le facteur 2 sort les secondaires de la borne basse de recharge (§6.3 :
 *  [2, 8] s). L'écart est celui qu'assume déjà le texte du nœud : la borne
 *  existe pour qu'une secondaire ne devienne pas une primaire bis, et FANAL a
 *  payé cette souplesse au prix fort — il n'a plus de bouton « annuler ».
 *
 *  ⚠️ Les +6 % de vitesse sont une contrepartie PROVISOIRE, et il faut le dire
 *  clairement : tant que `secondaryCooldownMul` n'est lu par personne, FANAL
 *  serait strictement PIRE que la coque de série, c'est-à-dire un nœud à
 *  1 800 crédits qui punit celui qui l'achète. Ces 6 % le maintiennent
 *  défendable en attendant. Le jour où la recharge accélérée s'applique
 *  réellement, ils sont à retirer — sinon FANAL cumule les deux contreparties
 *  pour un seul renoncement. `validateShips` reste satisfait sans eux, la
 *  promesse hors statistiques comptant déjà comme contrepartie. */
const fanal: ShipDef = {
  id: 'fanal',
  name: 'FANAL',
  modifiers: [
    { stat: Stat.MaxBombs, op: 'mul', value: -1 },
    { stat: Stat.MoveSpeed, op: 'mul', value: 0.06 },
  ],
  secondaryCooldownMul: 0.5,
  grazeBombCharge: 0,
  text: 'Aucune bombe. +6 % de vitesse, recharge des secondaires ×0,5.',
};

export default fanal;
